export const environment = {
  production: false,
  API : {
    RG_SEEKER_BACKEND_BASE_URL: {
      BASE_URL: 'https://samhita-rg-seeker-be-dev.samhita.org/api',
      END_POINT: {
        AUTH: {
          VERIFY_TOKEN: '/auth/verify-token/',
          BORROWERS: '/auth/borrowers',
          SIGN_UP: '/auth/signup/',
          LOGIN: '/auth/login/',
          ADMIN_LOGIN: '/login/',
          REFRESH_TOKEN: '/auth/token/refresh/',
          SEND_VERIFY_OTP: '/auth/agent-otp-login/',
          UPLOAD_DOCUMENT: '/auth/upload-pan-image/',
          UPLOAD_PAN_URL: '/auth/update-pan-image-url/',
          ME: '/auth/me/',
          AUTH2_URL: '/auth/get_oauth2_url',
          OAUTH_CALLBACK: '/auth/oauth2/callback'
        },
        SEEKER: {
          SEARCH : '/seeker/search/',
          INIT: '/seeker/init/',
          CONFIRM: '/seeker/confirm/',
          RG_PRODUCTS: '/rg-products/',
          PARTICIPANT_GRANT_DETAILS: '/rg-products/participant-grant-detail/',
          SELECT_RG_PRODUCT: '/rg-products/select/'
        },
        KYC: {
          CUSTOMER_REGISTRATION: '/kyc/customer-registration/',
          PAN_VERIFICATION: '/kyc/pan-verification/',
          POA_VERIFICATION: '/kyc/poa-verification/',
          POA_VERIFICATION_STATUS: '/kyc/poa-verification-status/',
          KYC_STATUS: '/kyc/kyc-status/',
          ACCOUNT_VERIFICATION: '/kyc/account-verification/',
          GET_TENANT_ACCESS_TOKEN: '/kyc/get-tenant-access-token/'
        },
        BECKN: {
          RG_PRODUCTS: '/beckn/rg-products/'
        }
      }
    },
  },
  SECRET_KEY : 'aB3dE5fG7hJ9kL2mN4pQ6rS8tU0vW3xY'
};
